module.exports = __webpack_public_path__ + "static/media/standard-menu-option.a78ef1d4.svg";